import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext.js';

const StatisticsDashboard = () => {
    const { token } = useAuth();
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchStats = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const response = await fetch('https://members.abssvss.com/members_api/get_dashboard_stats.php', {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await response.json();
                if (!response.ok) throw new Error('Failed to fetch stats.');
                setStats(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchStats();
    }, [token]);

    if (isLoading) return <p>Loading statistics...</p>;
    if (error) return <p className="text-red-500">Error: {error}</p>;
    if (!stats) return <p>Could not load statistics.</p>;

    return (
        <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-blue-100 p-6 rounded-lg text-center shadow">
                    <h3 className="text-4xl font-bold text-blue-800">{stats.totalMembers}</h3>
                    <p className="text-blue-600 font-semibold mt-2">Total Members</p>
                </div>
                 <div className="bg-yellow-100 p-6 rounded-lg text-center shadow">
                    <h3 className="text-4xl font-bold text-yellow-800">{stats.pendingMembers}</h3>
                    <p className="text-yellow-600 font-semibold mt-2">Pending Approvals</p>
                </div>
                 <div className="bg-orange-100 p-6 rounded-lg text-center shadow">
                    <h3 className="text-4xl font-bold text-orange-800">{stats.pendingEdits}</h3>
                    <p className="text-orange-600 font-semibold mt-2">Pending Edits</p>
                </div>
            </div>
            <div>
                <h2 className="text-2xl font-semibold text-gray-700 mb-4">Active Members by State</h2>
                <div className="bg-gray-50 p-4 rounded-lg border max-h-96 overflow-y-auto">
                    <ul className="space-y-2">
                        {stats.membersByState.length > 0 ? (
                            stats.membersByState.map(item => (
                                <li key={item.state} className="flex justify-between items-center p-2 rounded-md hover:bg-gray-100">
                                    <span className="font-medium text-gray-700">{item.state}</span>
                                    <span className="font-bold text-brand-primary bg-gray-200 px-2 py-1 rounded-full text-sm">{item.count}</span>
                                </li>
                            ))
                        ) : (
                            <p className="text-gray-500">No active members found.</p>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StatisticsDashboard;

